const containerStack = {
  padding: { xs: '4rem 2rem 2rem 2rem', m: '10rem 2.5rem 2.5rem 2.5rem' },
  gap: '3.75rem',
  background: 'linear-gradient(180deg, #18284D 0%, #000 100%)',
  position: 'relative',
  alignSelf: 'stretch',
};

const headerStack = {
  gap: '0.8rem',
  maxWidth: '80rem',
  width: '100%',
};

const titleTypography = (theme) => ({
  fontSize: '3rem',
  fontWeight: 700,
  color: theme.palette.primary.A700,
  textAlign: 'center',
});

const descriptionTypography = {
  fontWeight: 400,
  color: 'rgba(255, 255, 255, 0.80)',
  textAlign: 'center',
  padding: '0 1rem',
};

const valuesGrid = {
  display: 'grid',
  gridTemplateColumns: {
    smartphone: '1fr',
    sm: 'repeat(2, 1fr)',
    desktop: 'repeat(4, 1fr)',
  },
  flexDirection: 'row',
  justifyContent: 'center',
  gap: '1.5rem',
  mx: 'auto',
  width: '100%',
  height: '100%',
  maxWidth: '75rem',
};

const valueCard = (theme) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: '1.5rem 1rem',
  gap: '1rem',
  flex: '1 0 0',
  maxHeight: { xs: '100%', phone: '17.5rem' },
  minHeight: '15.5rem',
  height: '100%',
  borderRadius: '1.875rem',
  border: `1px solid ${theme.palette.neutral.A700}`,
  background: 'linear-gradient(52deg, rgba(255, 255, 255, 0.12) 4.6%, rgba(1, 72, 183, 0.12) 95.39%)',
});

const valueTitleTypography = {
  color: 'white',
  fontWeight: 500,
  fontSize: { xs: '1.25rem', sm: '1.125rem' },
};

const valueDescriptionTypography = {
  color: 'rgba(255, 255, 255, 0.70)',
  fontSize: '1rem',
};

export {
  containerStack,
  headerStack,
  titleTypography,
  descriptionTypography,
  valuesGrid,
  valueCard,
  valueTitleTypography,
  valueDescriptionTypography,
};
